var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/bookmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.98451 15.9727L7.98449 15.9727L7.99068 15.9762C9.03611 16.5611 10.2936 16.3978 11.4724 15.6884C11.4725 15.6883 11.4726 15.6883 11.4727 15.6882L12.6933 14.9559L13.9181 15.6889L13.9185 15.6891C14.7088 16.1611 15.4166 16.3298 16.0148 16.3298C16.638 16.3298 17.1239 16.1383 17.4263 15.962C18.4339 15.377 18.9448 14.2306 18.9448 12.9198V4.03983C18.9448 3.66069 19.3436 3.43051 19.644 3.57842L19.6462 3.5795C21.2465 4.35753 22.1948 5.9655 22.1948 8.30983V16.6898C22.1948 19.6237 19.8187 21.9998 16.8848 21.9998H8.50482C5.57097 21.9998 3.19482 19.6237 3.19482 16.6898V8.30983C3.19482 5.96563 4.14308 4.35771 5.74318 3.57963C6.05484 3.42872 6.44482 3.66073 6.44482 4.03983V12.9198C6.44482 14.2334 6.9577 15.3788 7.98451 15.9727Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.1753 13.7967L16.1753 13.7967L16.1713 13.799C16.1361 13.8198 16.0477 13.8494 15.8701 13.8178C15.694 13.7864 15.4666 13.6999 15.2021 13.5413L15.2016 13.541L13.8845 12.7527C13.884 12.7524 13.8834 12.7521 13.8829 12.7517C13.5314 12.5386 13.0989 12.4475 12.6948 12.4475C12.2907 12.4475 11.8582 12.5386 11.5068 12.7517C11.5062 12.7521 11.5057 12.7524 11.5051 12.7527L10.1881 13.541L10.1876 13.5413C9.92538 13.6986 9.69853 13.783 9.52196 13.8136C9.34751 13.8438 9.25323 13.8172 9.21158 13.7951C9.12082 13.7401 8.94482 13.502 8.94482 12.92V3.5C8.94482 3.22614 9.17097 3 9.44482 3H15.9448C16.2187 3 16.4448 3.22614 16.4448 3.5V12.92C16.4448 13.5079 16.2653 13.7449 16.1753 13.7967Z",
    fill: "black",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.3725a17f9e7f7395948512cc83a8d74f.svg";
export { ForwardRef as ReactComponent };